import { render } from "./Layout.vue?vue&type=template&id=0a500184&scoped=true"
import script from "./Layout.vue?vue&type=script&lang=js"
export * from "./Layout.vue?vue&type=script&lang=js"

import "./Layout.vue?vue&type=style&index=0&id=0a500184&lang=less&scoped=true"

import exportComponent from "../../node_modules/.store/vue-loader@17.1.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a500184"]])

export default __exports__